// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Text alignment (editor + client view) */
.ql-editor .ql-align-center,
.diet-html-content .ql-align-center {
  text-align: center;
}

.ql-editor .ql-align-right,
.diet-html-content .ql-align-right {
  text-align: right;
}

.ql-editor .ql-align-justify,
.diet-html-content .ql-align-justify {
  text-align: justify;
}

/* Reduce left spacing for bullet/ordered lists in editors */
.rich-editor .ql-editor,
.view-only .ql-editor {
  padding: 10px 12px;
}

.rich-editor .ql-editor ol,
.rich-editor .ql-editor ul,
.view-only .ql-editor ol,
.view-only .ql-editor ul {
  padding-left: 0.5em;
  margin: 0.25em 0;
}

.rich-editor .ql-editor li,
.view-only .ql-editor li {
  padding-left: 1em;
}

/* Client diet view list spacing */
.diet-html-content ol,
.diet-html-content ul {
  padding-left: 0.75em;
  margin: 0.25em 0;
}

.diet-html-content li {
  padding-left: 0.35em;
}

.diet-html-content ol {
  list-style: none;
}

.diet-html-content li[data-list='bullet']::before {
  content: '\\2022';
  display: inline-block;
  width: 0.75em;
  margin-left: -0.75em;
  margin-right: 0.25em;
}

.diet-html-content li[data-list='ordered'] {
  counter-increment: list-0;
}

.diet-html-content li[data-list='ordered']::before {
  content: counter(list-0) '. ';
  display: inline-block;
  width: 1.25em;
  margin-left: -1.25em;
  margin-right: 0.15em;
}

.diet-html-content ol {
  counter-reset: list-0;
}

.diet-html-content ul {
  list-style-type: disc;
  padding-left: 1em;
}
`, "",{"version":3,"sources":["webpack://./src/styles/DietRichText.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,4DAA4D;AAC5D;;EAEE,kBAAkB;AACpB;;AAEA;;;;EAIE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC;;EAEE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,aAAa;EACb,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB","sourcesContent":["/* Text alignment (editor + client view) */\n.ql-editor .ql-align-center,\n.diet-html-content .ql-align-center {\n  text-align: center;\n}\n\n.ql-editor .ql-align-right,\n.diet-html-content .ql-align-right {\n  text-align: right;\n}\n\n.ql-editor .ql-align-justify,\n.diet-html-content .ql-align-justify {\n  text-align: justify;\n}\n\n/* Reduce left spacing for bullet/ordered lists in editors */\n.rich-editor .ql-editor,\n.view-only .ql-editor {\n  padding: 10px 12px;\n}\n\n.rich-editor .ql-editor ol,\n.rich-editor .ql-editor ul,\n.view-only .ql-editor ol,\n.view-only .ql-editor ul {\n  padding-left: 0.5em;\n  margin: 0.25em 0;\n}\n\n.rich-editor .ql-editor li,\n.view-only .ql-editor li {\n  padding-left: 1em;\n}\n\n/* Client diet view list spacing */\n.diet-html-content ol,\n.diet-html-content ul {\n  padding-left: 0.75em;\n  margin: 0.25em 0;\n}\n\n.diet-html-content li {\n  padding-left: 0.35em;\n}\n\n.diet-html-content ol {\n  list-style: none;\n}\n\n.diet-html-content li[data-list='bullet']::before {\n  content: '\\2022';\n  display: inline-block;\n  width: 0.75em;\n  margin-left: -0.75em;\n  margin-right: 0.25em;\n}\n\n.diet-html-content li[data-list='ordered'] {\n  counter-increment: list-0;\n}\n\n.diet-html-content li[data-list='ordered']::before {\n  content: counter(list-0) '. ';\n  display: inline-block;\n  width: 1.25em;\n  margin-left: -1.25em;\n  margin-right: 0.15em;\n}\n\n.diet-html-content ol {\n  counter-reset: list-0;\n}\n\n.diet-html-content ul {\n  list-style-type: disc;\n  padding-left: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
